var map = {
	"./academic-cap": 22695,
	"./academic-cap.js": 22695,
	"./adjustments": 8849,
	"./adjustments.js": 8849,
	"./annotation": 37040,
	"./annotation.js": 37040,
	"./archive": 32327,
	"./archive.js": 32327,
	"./arrow-circle-down": 8930,
	"./arrow-circle-down.js": 8930,
	"./arrow-circle-left": 71723,
	"./arrow-circle-left.js": 71723,
	"./arrow-circle-right": 37298,
	"./arrow-circle-right.js": 37298,
	"./arrow-circle-up": 66747,
	"./arrow-circle-up.js": 66747,
	"./arrow-down": 12185,
	"./arrow-down.js": 12185,
	"./arrow-left": 81128,
	"./arrow-left.js": 81128,
	"./arrow-narrow-down": 9991,
	"./arrow-narrow-down.js": 9991,
	"./arrow-narrow-left": 36670,
	"./arrow-narrow-left.js": 36670,
	"./arrow-narrow-right": 98185,
	"./arrow-narrow-right.js": 98185,
	"./arrow-narrow-up": 26018,
	"./arrow-narrow-up.js": 26018,
	"./arrow-right": 619,
	"./arrow-right.js": 619,
	"./arrow-up": 86584,
	"./arrow-up.js": 86584,
	"./arrows-expand": 81000,
	"./arrows-expand.js": 81000,
	"./at-symbol": 1449,
	"./at-symbol.js": 1449,
	"./backspace": 85186,
	"./backspace.js": 85186,
	"./badge-check": 11971,
	"./badge-check.js": 11971,
	"./ban": 51196,
	"./ban.js": 51196,
	"./beaker": 27255,
	"./beaker.js": 27255,
	"./bell": 29324,
	"./bell.js": 29324,
	"./book-open": 79881,
	"./book-open.js": 79881,
	"./bookmark": 83765,
	"./bookmark-alt": 63091,
	"./bookmark-alt.js": 63091,
	"./bookmark.js": 83765,
	"./briefcase": 15833,
	"./briefcase.js": 15833,
	"./cake": 36033,
	"./cake.js": 36033,
	"./calculator": 58893,
	"./calculator.js": 58893,
	"./calendar": 8803,
	"./calendar.js": 8803,
	"./camera": 21618,
	"./camera.js": 21618,
	"./cash": 26526,
	"./cash.js": 26526,
	"./chart-bar": 857,
	"./chart-bar.js": 857,
	"./chart-pie": 97906,
	"./chart-pie.js": 97906,
	"./chart-square-bar": 91077,
	"./chart-square-bar.js": 91077,
	"./chat": 27411,
	"./chat-alt": 37313,
	"./chat-alt-2": 70394,
	"./chat-alt-2.js": 70394,
	"./chat-alt.js": 37313,
	"./chat.js": 27411,
	"./check": 78653,
	"./check-circle": 89730,
	"./check-circle.js": 89730,
	"./check.js": 78653,
	"./chevron-double-down": 87307,
	"./chevron-double-down.js": 87307,
	"./chevron-double-left": 85810,
	"./chevron-double-left.js": 85810,
	"./chevron-double-right": 73109,
	"./chevron-double-right.js": 73109,
	"./chevron-double-up": 26894,
	"./chevron-double-up.js": 26894,
	"./chevron-down": 96947,
	"./chevron-down.js": 96947,
	"./chevron-left": 58634,
	"./chevron-left.js": 58634,
	"./chevron-right": 10541,
	"./chevron-right.js": 10541,
	"./chevron-up": 92022,
	"./chevron-up.js": 92022,
	"./chip": 32543,
	"./chip.js": 32543,
	"./clipboard": 62635,
	"./clipboard-check": 95854,
	"./clipboard-check.js": 95854,
	"./clipboard-copy": 8877,
	"./clipboard-copy.js": 8877,
	"./clipboard-list": 42424,
	"./clipboard-list.js": 42424,
	"./clipboard.js": 62635,
	"./clock": 31187,
	"./clock.js": 31187,
	"./cloud": 49108,
	"./cloud-download": 8953,
	"./cloud-download.js": 8953,
	"./cloud-upload": 35928,
	"./cloud-upload.js": 35928,
	"./cloud.js": 49108,
	"./code": 1724,
	"./code.js": 1724,
	"./cog": 70434,
	"./cog.js": 70434,
	"./collection": 10805,
	"./collection.js": 10805,
	"./color-swatch": 62443,
	"./color-swatch.js": 62443,
	"./command-line": 1831,
	"./command-line.js": 1831,
	"./credit-card": 79795,
	"./credit-card.js": 79795,
	"./cube": 67044,
	"./cube-transparent": 58447,
	"./cube-transparent.js": 58447,
	"./cube.js": 67044,
	"./currency-bangladeshi": 78799,
	"./currency-bangladeshi.js": 78799,
	"./currency-dollar": 98101,
	"./currency-dollar.js": 98101,
	"./currency-euro": 40294,
	"./currency-euro.js": 40294,
	"./currency-pound": 8385,
	"./currency-pound.js": 8385,
	"./currency-rupee": 8186,
	"./currency-rupee.js": 8186,
	"./currency-yen": 20140,
	"./currency-yen.js": 20140,
	"./cursor-click": 54586,
	"./cursor-click.js": 54586,
	"./dark-modal-back-button": 82274,
	"./dark-modal-back-button.js": 82274,
	"./database": 67788,
	"./database.js": 67788,
	"./desktop-computer": 93223,
	"./desktop-computer.js": 93223,
	"./device-mobile": 97286,
	"./device-mobile.js": 97286,
	"./device-tablet": 23960,
	"./device-tablet.js": 23960,
	"./document": 40444,
	"./document-add": 20862,
	"./document-add.js": 20862,
	"./document-download": 75201,
	"./document-download.js": 75201,
	"./document-duplicate": 50932,
	"./document-duplicate.js": 50932,
	"./document-remove": 17149,
	"./document-remove.js": 17149,
	"./document-report": 50035,
	"./document-report.js": 50035,
	"./document-search": 64761,
	"./document-search.js": 64761,
	"./document-text": 14606,
	"./document-text.js": 14606,
	"./document.js": 40444,
	"./dots-circle-horizontal": 65191,
	"./dots-circle-horizontal.js": 65191,
	"./dots-horizontal": 12254,
	"./dots-horizontal.js": 12254,
	"./dots-vertical": 32140,
	"./dots-vertical.js": 32140,
	"./download": 44517,
	"./download.js": 44517,
	"./duplicate": 21520,
	"./duplicate.js": 21520,
	"./emoji-happy": 64864,
	"./emoji-happy.js": 64864,
	"./emoji-sad": 87198,
	"./emoji-sad.js": 87198,
	"./exclamation": 97760,
	"./exclamation-circle": 85869,
	"./exclamation-circle.js": 85869,
	"./exclamation.js": 97760,
	"./external-link": 27459,
	"./external-link.js": 27459,
	"./eye": 6984,
	"./eye-off": 31156,
	"./eye-off.js": 31156,
	"./eye.js": 6984,
	"./fast-forward": 15715,
	"./fast-forward.js": 15715,
	"./film": 48115,
	"./film.js": 48115,
	"./filter": 11963,
	"./filter.js": 11963,
	"./finger-print": 8374,
	"./finger-print.js": 8374,
	"./fire": 54057,
	"./fire.js": 54057,
	"./flag": 65315,
	"./flag.js": 65315,
	"./folder": 36045,
	"./folder-add": 25843,
	"./folder-add.js": 25843,
	"./folder-download": 67706,
	"./folder-download.js": 67706,
	"./folder-open": 47738,
	"./folder-open.js": 47738,
	"./folder-remove": 1238,
	"./folder-remove.js": 1238,
	"./folder.js": 36045,
	"./gift": 48183,
	"./gift.js": 48183,
	"./github": 178,
	"./github.js": 178,
	"./globe": 79660,
	"./globe-alt": 75862,
	"./globe-alt.js": 75862,
	"./globe.js": 79660,
	"./gold-badge": 7225,
	"./gold-badge-icon": 88171,
	"./gold-badge-icon.js": 88171,
	"./gold-badge.js": 7225,
	"./hand": 61740,
	"./hand.js": 61740,
	"./hashtag": 4737,
	"./hashtag.js": 4737,
	"./heart": 69505,
	"./heart.js": 69505,
	"./home": 59438,
	"./home.js": 59438,
	"./identification": 62083,
	"./identification.js": 62083,
	"./inbox": 77053,
	"./inbox-in": 94017,
	"./inbox-in.js": 94017,
	"./inbox.js": 77053,
	"./information-circle": 64496,
	"./information-circle.js": 64496,
	"./key": 72938,
	"./key.js": 72938,
	"./library": 31198,
	"./library.js": 31198,
	"./light-bulb": 3889,
	"./light-bulb.js": 3889,
	"./lightning-bolt": 46167,
	"./lightning-bolt.js": 46167,
	"./link": 74677,
	"./link.js": 74677,
	"./location-marker": 62857,
	"./location-marker.js": 62857,
	"./lock-closed": 98391,
	"./lock-closed.js": 98391,
	"./lock-open": 59047,
	"./lock-open.js": 59047,
	"./login": 29060,
	"./login.js": 29060,
	"./logout": 73515,
	"./logout.js": 73515,
	"./mail": 61410,
	"./mail-open": 63371,
	"./mail-open.js": 63371,
	"./mail.js": 61410,
	"./map": 87291,
	"./map.js": 87291,
	"./markdown": 33700,
	"./markdown.js": 33700,
	"./menu": 15390,
	"./menu-alt-1": 86226,
	"./menu-alt-1.js": 86226,
	"./menu-alt-2": 93023,
	"./menu-alt-2.js": 93023,
	"./menu-alt-3": 936,
	"./menu-alt-3.js": 936,
	"./menu-alt-4": 96989,
	"./menu-alt-4.js": 96989,
	"./menu.js": 15390,
	"./microphone": 73457,
	"./microphone.js": 73457,
	"./minus": 7409,
	"./minus-circle": 17913,
	"./minus-circle.js": 17913,
	"./minus-sm": 80146,
	"./minus-sm.js": 80146,
	"./minus.js": 7409,
	"./moon": 13108,
	"./moon.js": 13108,
	"./music-note": 99199,
	"./music-note.js": 99199,
	"./newspaper": 12234,
	"./newspaper.js": 12234,
	"./office-building": 39182,
	"./office-building.js": 39182,
	"./paper-airplane": 34166,
	"./paper-airplane.js": 34166,
	"./paper-clip": 5534,
	"./paper-clip.js": 5534,
	"./pause": 10123,
	"./pause.js": 10123,
	"./pencil": 39796,
	"./pencil-alt": 5438,
	"./pencil-alt.js": 5438,
	"./pencil.js": 39796,
	"./phone": 18381,
	"./phone-incoming": 64970,
	"./phone-incoming.js": 64970,
	"./phone-missed-call": 25900,
	"./phone-missed-call.js": 25900,
	"./phone-outgoing": 46216,
	"./phone-outgoing.js": 46216,
	"./phone.js": 18381,
	"./photograph": 18733,
	"./photograph.js": 18733,
	"./play": 90323,
	"./play.js": 90323,
	"./plus": 37865,
	"./plus-circle": 41534,
	"./plus-circle.js": 41534,
	"./plus-sm": 83066,
	"./plus-sm.js": 83066,
	"./plus.js": 37865,
	"./presentation-chart-bar": 15308,
	"./presentation-chart-bar.js": 15308,
	"./presentation-chart-line": 1027,
	"./presentation-chart-line.js": 1027,
	"./printer": 64233,
	"./printer.js": 64233,
	"./puzzle": 19289,
	"./puzzle.js": 19289,
	"./qrcode": 16487,
	"./qrcode.js": 16487,
	"./question-mark-circle": 7044,
	"./question-mark-circle.js": 7044,
	"./receipt-refund": 7244,
	"./receipt-refund.js": 7244,
	"./receipt-tax": 7637,
	"./receipt-tax.js": 7637,
	"./refresh": 90234,
	"./refresh.js": 90234,
	"./reply": 52489,
	"./reply.js": 52489,
	"./rewind": 54138,
	"./rewind.js": 54138,
	"./rss": 41561,
	"./rss.js": 41561,
	"./save": 59172,
	"./save-as": 24125,
	"./save-as.js": 24125,
	"./save.js": 59172,
	"./scale": 87319,
	"./scale.js": 87319,
	"./scissors": 70762,
	"./scissors.js": 70762,
	"./search": 70621,
	"./search-circle": 84578,
	"./search-circle.js": 84578,
	"./search.js": 70621,
	"./selector": 15460,
	"./selector.js": 15460,
	"./server": 81478,
	"./server.js": 81478,
	"./share": 71482,
	"./share.js": 71482,
	"./shield-check": 13441,
	"./shield-check.js": 13441,
	"./shield-exclamation": 34716,
	"./shield-exclamation.js": 34716,
	"./shopping-bag": 2366,
	"./shopping-bag.js": 2366,
	"./shopping-cart": 78160,
	"./shopping-cart.js": 78160,
	"./sort-ascending": 68986,
	"./sort-ascending.js": 68986,
	"./sort-descending": 43480,
	"./sort-descending.js": 43480,
	"./sparkles": 96654,
	"./sparkles.js": 96654,
	"./speakerphone": 77682,
	"./speakerphone.js": 77682,
	"./spinner": 63832,
	"./spinner.js": 63832,
	"./star": 68173,
	"./star.js": 68173,
	"./status-offline": 97125,
	"./status-offline.js": 97125,
	"./status-online": 10867,
	"./status-online.js": 10867,
	"./stop": 97093,
	"./stop.js": 97093,
	"./sun": 60379,
	"./sun.js": 60379,
	"./support": 6594,
	"./support.js": 6594,
	"./switch-horizontal": 11010,
	"./switch-horizontal.js": 11010,
	"./switch-vertical": 13928,
	"./switch-vertical.js": 13928,
	"./table": 60905,
	"./table.js": 60905,
	"./tag": 59437,
	"./tag.js": 59437,
	"./template": 48243,
	"./template.js": 48243,
	"./terminal": 15133,
	"./terminal-outline": 34150,
	"./terminal-outline.js": 34150,
	"./terminal.js": 15133,
	"./thumb-down": 83862,
	"./thumb-down.js": 83862,
	"./thumb-up": 84087,
	"./thumb-up.js": 84087,
	"./ticket": 25105,
	"./ticket.js": 25105,
	"./translate": 97943,
	"./translate.js": 97943,
	"./trash": 91199,
	"./trash.js": 91199,
	"./trending-down": 9589,
	"./trending-down.js": 9589,
	"./trending-up": 82956,
	"./trending-up.js": 82956,
	"./truck": 85022,
	"./truck.js": 85022,
	"./upload": 35132,
	"./upload.js": 35132,
	"./user": 71582,
	"./user-add": 3024,
	"./user-add.js": 3024,
	"./user-circle": 95179,
	"./user-circle.js": 95179,
	"./user-group": 65496,
	"./user-group.js": 65496,
	"./user-remove": 51487,
	"./user-remove.js": 51487,
	"./user.js": 71582,
	"./users": 80789,
	"./users.js": 80789,
	"./variable": 90497,
	"./variable.js": 90497,
	"./video-camera": 21648,
	"./video-camera.js": 21648,
	"./view-boards": 18744,
	"./view-boards.js": 18744,
	"./view-grid": 8909,
	"./view-grid-add": 25043,
	"./view-grid-add.js": 25043,
	"./view-grid.js": 8909,
	"./view-list": 30601,
	"./view-list.js": 30601,
	"./volume-off": 51663,
	"./volume-off.js": 51663,
	"./volume-up": 46665,
	"./volume-up.js": 46665,
	"./wifi": 89684,
	"./wifi.js": 89684,
	"./x": 38761,
	"./x-circle": 70174,
	"./x-circle.js": 70174,
	"./x.js": 38761,
	"./zoom-in": 71584,
	"./zoom-in.js": 71584,
	"./zoom-out": 16559,
	"./zoom-out.js": 16559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23827;